import React from 'react'
import PersonalInformation from './PersonalInformation'
import Security from './Security'
import General from './General'

const UserSettings = () => {
  return (
    <>
      <PersonalInformation />
      <hr className='m-auto w-full border-[#E2E2E2]' />
      <Security />
      <hr className='m-auto w-full border-[#E2E2E2]' />
      <General />
    </>
  )
}

export default UserSettings
